export { default } from '@abyss/core/next-app';